import type React from 'react';

import { SettingsIcon } from '@vlabs/icons';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button';
import { Button } from '@vlabs/uikit/components/controls/button';
// ponytail: осознанный импорт роутов приложения — компонент используется только в point3 (GUI-3947)
import { routes } from '@vlapps/point3/src/app/routes';
import { generatePath, Link } from 'react-router-dom';

import { useGoToSourceGroupTranslation } from '../i18n';
import type { GoToSourceGroupProps } from '../types';

function GoToSourceGroupButton({
  groupId,
  ...props
}: GoToSourceGroupProps & ButtonProps): React.JSX.Element {
  const { t } = useGoToSourceGroupTranslation();

  return (
    <Button
      as={Link}
      data-testid="goToSourceGroupButton"
      icon={<SettingsIcon />}
      kind="secondary"
      size="small"
      to={generatePath(routes.sources.groupView, { groupId })}
      variant="outlined"
      {...props}
    >
      {t('title')}
    </Button>
  );
}

export { GoToSourceGroupButton };
